<script setup lang="ts">
/**
 * App-wide gates and prompts from the store-readiness work, mounted once in App.vue:
 * - the minimum-version gate (native only, U-15);
 * - the AI consent sheet / "AI consent needed" screen (companion mode, D-7);
 * - the support-access request (web and native, D-16);
 * - the "account deleted" confirmation (U-2).
 */
import { defineAsyncComponent } from 'vue'
import { isNativePlatform } from '@/utils/platform'
import { GUEST_MODE } from '@/guest/guestMode'
import { aiConsentEnforced } from '@/composables/useAiConsent'
import AccountDeletedScreen from '@/components/account/AccountDeletedScreen.vue'

const AppUpdateGate = defineAsyncComponent(() => import('./AppUpdateGate.vue'))
const AiConsentGate = defineAsyncComponent(() => import('@/components/consent/AiConsentGate.vue'))
const SupportAccessPrompt = defineAsyncComponent(() => import('@/components/support/SupportAccessPrompt.vue'))

const native = isNativePlatform()
const consentEnforced = aiConsentEnforced()
</script>

<template>
    <template v-if="!GUEST_MODE">
        <SupportAccessPrompt />
        <AiConsentGate v-if="consentEnforced" />
        <AppUpdateGate v-if="native" />
    </template>
    <AccountDeletedScreen />
</template>
